// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__eLw92","tabs--border":"Tabs_tabs--border__sVjQu"};